var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFraud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bulk_note",
    "data-name": "vuesax/bulk/note",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10040",
    "data-name": "Path 10040",
    d: "M15.055,5.79,18.561,9.3,9.033,18.824,5.254,15.277Z",
    transform: "translate(0 -0.307)",
    fill: "#4c1036",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.323,11.793a.059.059,0,0,0,.019-.038L11.736,1.361c.019-.019.038-.019.057-.038A7.357,7.357,0,0,0,7.559,0,7.557,7.557,0,0,0,0,7.559a7.41,7.41,0,0,0,1.1,3.893Z",
    transform: "translate(4.441 4.441)",
    fill: "#4c1036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M10.489,0c-.019.019-.019.038-.038.057L.057,10.451c-.019.019-.038.019-.057.038A7.518,7.518,0,0,0,10.715,8.145a7.41,7.41,0,0,0,1.1-3.893A7.461,7.461,0,0,0,10.489,0Z",
    transform: "translate(7.748 7.748)",
    fill: "#4c1036"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraud);
export default __webpack_public_path__ + "static/media/fraud.d8942ded1e323e60867cf9047e77b984.svg";
export { ForwardRef as ReactComponent };